// jQuery(document).ready(function () {
//   jQuery(".js-property-filter").select2();

//   // Set initial filter value from URL, if available
//   const urlParams = new URLSearchParams(window.location.search);
//   const initialFilter = urlParams.get("sort") || "all";
//   const filterDropdown = document.querySelector(".js-property-filter");

//   // Set the selected option based on the URL parameter
//   if (filterDropdown) {
//     filterDropdown.value = initialFilter;
//     // Trigger change event to update the select2 UI
//     jQuery(filterDropdown).trigger("change");
//   }

//   // Event listener for the filter dropdown
//   jQuery(".js-property-filter").on("change", function () {
//     const sortValue = jQuery(this).val();
//     const currentUrl = window.location.href.split("?")[0]; // Get current URL without query parameters
//     window.location.href = `${currentUrl}?sort=${sortValue}`; // Redirect to the same page with the selected sort option
//   });

//   // Select all elements with the class 'coordinates'
//   const mapElements = document.querySelectorAll(".coordinates");

//   // Set the Mapbox access token
//   mapboxgl.accessToken =
//     "pk.eyJ1IjoidmlhZGlncm91cCIsImEiOiJjbHdnOTI5cGQwMmp3MmpwYW9sMWp6bzF3In0.xZeoQnGcB-dSo6QyS46WhA";

//   // Function to get the route
//   async function getRoute(start, end, profile = "driving") {
//     try {
//       const response = await fetch(
//         `https://api.mapbox.com/directions/v5/mapbox/${profile}/${start[0]},${start[1]};${end[0]},${end[1]}?steps=true&geometries=geojson&access_token=${mapboxgl.accessToken}`,
//         { method: "GET" }
//       );

//       const data = await response.json();
//       if (data.routes && data.routes.length > 0) {
//         return data.routes[0];
//       } else {
//         throw new Error("Route not found");
//       }
//     } catch (error) {
//       console.error("Error while fetching the route:", error);
//       return null;
//     }
//   }

//   // Function to update distance information for a specific block
//   async function updateDistanceData(mapElement) {
//     const dataStart = mapElement.getAttribute("data-start");

//     if (!dataStart) {
//       console.error("Coordinates start data missing.");
//       return;
//     }

//     const startCoordinates = dataStart
//       .split(",")
//       .map((coord) => parseFloat(coord.trim())); // Convert strings to numbers

//     const start = startCoordinates; // Start coordinates
//     const end = [9.8385807, 46.8065311]; // End coordinates

//     const drivingRoute = await getRoute(start, end, "driving");
//     const walkingRoute = await getRoute(start, end, "walking");

//     if (drivingRoute && walkingRoute) {
//       const drivingTime = (drivingRoute.duration / 60).toFixed(0); // Convert seconds to minutes
//       const walkingTime = (walkingRoute.duration / 60).toFixed(0); // Convert seconds to minutes

//       // Update the grid item with the distance data
//       const gridItem = mapElement.closest(".grid__item");
//       gridItem.dataset.walkingDistance = walkingTime;
//       gridItem.dataset.drivingDistance = drivingTime;

//       const distanceElement =
//         mapElement.parentElement.querySelector(".articleDistance");
//       if (distanceElement) {
//         distanceElement.textContent = `Distance to Congress Center: ${walkingTime} minute walk / ${drivingTime} minute drive`;
//       }
//     }
//   }

//   // Iterate through each map element and calculate distances
//   const updateTasks = Array.from(mapElements).map((mapElement) => {
//     return updateDistanceData(mapElement);
//   });

//   // Wait for all distance updates to complete before applying the filter
//   Promise.all(updateTasks).then(() => {
//     filterProperties();
//   });

//   // Function to filter properties based on the selected distance
//   function filterProperties() {
//     const filter = document.querySelector(".js-property-filter").value;
//     const gridItems = Array.from(document.querySelectorAll(".grid__item"));

//     // Sort grid items based on the selected filter
//     if (filter?.includes("walking") || filter?.includes("driving")) {
//       const isWalking = filter.includes("walking");
//       const isAscending = filter.includes("asc");

//       gridItems.sort((a, b) => {
//         const aDistance = parseInt(
//           a.getAttribute(
//             isWalking ? "data-walking-distance" : "data-driving-distance"
//           ),
//           10
//         );
//         const bDistance = parseInt(
//           b.getAttribute(
//             isWalking ? "data-walking-distance" : "data-driving-distance"
//           ),
//           10
//         );

//         // Sort based on ascending or descending
//         return isAscending ? aDistance - bDistance : bDistance - aDistance;
//       });
//     } else if (filter?.includes("capacity")) {
//       const isAscending = filter.includes("asc");

//       gridItems.sort((a, b) => {
//         const aCapacity = parseInt(a.getAttribute("data-guests"), 10) || 0;
//         const bCapacity = parseInt(b.getAttribute("data-guests"), 10) || 0;

//         // Sort based on ascending or descending
//         return isAscending ? aCapacity - bCapacity : bCapacity - aCapacity;
//       });
//     }

//     // Apply sorting logic and update item visibility
//     gridItems.forEach((item, index) => {
//       const dataWalkingDistance = item.getAttribute("data-walking-distance");
//       const dataDrivingDistance = item.getAttribute("data-driving-distance");

//       let isVisible = true; // Default visibility to true

//       // Check if the distances are available and valid
//       const isWalkingValid =
//         dataWalkingDistance && !isNaN(parseInt(dataWalkingDistance, 10));
//       const isDrivingValid =
//         dataDrivingDistance && !isNaN(parseInt(dataDrivingDistance, 10));

//       // Only hide items if the filter is not "all"
//       if (filter !== "all") {
//         if (filter.includes("walking")) {
//           isVisible = isWalkingValid && parseInt(dataWalkingDistance, 10) > 0;
//         } else if (filter.includes("driving")) {
//           isVisible = isDrivingValid && parseInt(dataDrivingDistance, 10) > 0;
//         }
//       }

//       // Apply visibility and animation
//       if (isVisible) {
//         item.classList.remove("hidden");
//         item.classList.add("visible");
//       } else {
//         item.classList.remove("visible");
//         item.classList.add("hidden");
//       }
//       item.style.order = index; // Maintain order after sorting
//     });
//   }
// });

jQuery(document).ready(function () {
  // Initialize Select2 on the sort dropdown
  jQuery(".js-property-filter").select2();

  // Read the initial sort value from the URL (default to "all")
  const urlParams = new URLSearchParams(window.location.search);
  const initialFilter = urlParams.get("sort") || "all";
  const filterDropdown = document.querySelector(".js-property-filter");

  // If we found the dropdown, set its value and update the UI
  if (filterDropdown) {
    filterDropdown.value = initialFilter;
    jQuery(filterDropdown).trigger("change");
  }

  // When the user changes the sort option, reload the page with the new sort param
  jQuery(".js-property-filter").on("change", function () {
    const sortValue = jQuery(this).val();
    const currentUrl = window.location.href.split("?")[0];
    window.location.href = `${currentUrl}?sort=${sortValue}`;
  });

  // Grab all elements that hold starting coordinates
  const mapElements = document.querySelectorAll(".coordinates");

  // Configure your Mapbox access token
  mapboxgl.accessToken =
    "pk.eyJ1IjoidmlhZGlncm91cCIsImEiOiJjbHdnOTI5cGQwMmp3MmpwYW9sMWp6bzF3In0.xZeoQnGcB-dSo6QyS46WhA";

  /**
   * Fetch a route from Mapbox Directions API.
   * @param {[number, number]} start  - [lng, lat] of start
   * @param {[number, number]} end    - [lng, lat] of end
   * @param {string} profile          - "driving" or "walking"
   * @returns {Object|null}           - The first route object, or null if none
   */
  async function getRoute(start, end, profile = "driving") {
    try {
      const url =
        `https://api.mapbox.com/directions/v5/mapbox/${profile}/` +
        `${start[0]},${start[1]};${end[0]},${end[1]}` +
        `?steps=true&geometries=geojson&access_token=${mapboxgl.accessToken}`;
      const response = await fetch(url, { method: "GET" });
      const data = await response.json();
      if (data.routes && data.routes.length > 0) {
        return data.routes[0];
      } else {
        throw new Error("No route returned");
      }
    } catch (error) {
      console.error("Error fetching route:", error);
      return null;
    }
  }

  /**
   * Update distance metadata and displayed text for one .coordinates element.
   * Then re-run the sorting/filter so this item moves into place.
   */
  async function updateDistanceData(mapElement) {
    const dataStart = mapElement.getAttribute("data-start");
    if (!dataStart) {
      console.error("Missing data-start on coordinates element");
      return;
    }

    // Parse the "lng,lat" string into numbers
    const startCoordinates = dataStart
      .split(",")
      .map((c) => parseFloat(c.trim()));
    const endCoordinates = [9.8385807, 46.8065311]; // Congress Center

    // Fetch both driving and walking routes
    const [drivingRoute, walkingRoute] = await Promise.all([
      getRoute(startCoordinates, endCoordinates, "driving"),
      getRoute(startCoordinates, endCoordinates, "walking"),
    ]);

    if (drivingRoute && walkingRoute) {
      // Convert seconds ➔ minutes, rounded
      const drivingTime = Math.round(drivingRoute.duration / 60);
      const walkingTime = Math.round(walkingRoute.duration / 60);

      // Find the grid item container and store the distances in data-attributes
      const gridItem = mapElement.closest(".grid__item");
      gridItem.dataset.drivingDistance = drivingTime;
      gridItem.dataset.walkingDistance = walkingTime;

      // Update the visible text inside .articleDistance
      const distanceElement =
        mapElement.parentElement.querySelector(".articleDistance");
      if (distanceElement) {
        distanceElement.textContent = `Distance to Congress Center: ${walkingTime} minute walk / ${drivingTime} minute drive`;
      }

      // Re-run sorting/filtering so this item moves into its correct spot immediately
      filterProperties();
    }
  }

  // Immediately render all items (no waiting) in the default order or according to URL param
  filterProperties();

  // Kick off distance calculations for each element; they will update themselves as they return
  mapElements.forEach((el) => updateDistanceData(el));

  /**
   * Sorts and filters all .grid__item elements based on the selected filter:
   * - walking-asc / walking-desc
   * - driving-asc / driving-desc
   * - capacity-asc / capacity-desc
   * - all (no filtering)
   */
  function filterProperties() {
    const filter = document.querySelector(".js-property-filter").value;
    const items = Array.from(document.querySelectorAll(".grid__item"));

    // Choose sorting key and direction
    if (filter.includes("walking") || filter.includes("driving")) {
      const isWalk = filter.includes("walking");
      const asc = filter.includes("asc");
      items.sort((a, b) => {
        const aVal =
          parseInt(
            a.dataset[isWalk ? "walkingDistance" : "drivingDistance"],
            10
          ) || Infinity;
        const bVal =
          parseInt(
            b.dataset[isWalk ? "walkingDistance" : "drivingDistance"],
            10
          ) || Infinity;
        return asc ? aVal - bVal : bVal - aVal;
      });
    } else if (filter.includes("capacity")) {
      const asc = filter.includes("asc");
      items.sort((a, b) => {
        const aCap = parseInt(a.dataset.guests, 10) || 0;
        const bCap = parseInt(b.dataset.guests, 10) || 0;
        return asc ? aCap - bCap : bCap - aCap;
      });
    }

    // Apply sorted order and hide/show items if filtering by distance
    items.forEach((item, idx) => {
      let visible = true;
      if (filter !== "all") {
        if (filter.includes("walking")) {
          const d = parseInt(item.dataset.walkingDistance, 10);
          visible = !isNaN(d) && d > 0;
        } else if (filter.includes("driving")) {
          const d = parseInt(item.dataset.drivingDistance, 10);
          visible = !isNaN(d) && d > 0;
        }
      }
      item.classList.toggle("hidden", !visible);
      item.classList.toggle("visible", visible);
      item.style.order = idx;
    });
  }
});
